"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const SubclientController_1 = __importDefault(require("@becrop/components/Modules/Common/controllers/SubclientController"));
let CustomerSwitcher = class CustomerSwitcher extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.controller = new SubclientController_1.default();
        this.subclientsFilters = [];
    }
    created() {
        this.callSubclients();
    }
    async callSubclients() {
        await this.controller.fetchAllSubclients('/biomemakers-subclients/data/subclients');
    }
    get subclients() {
        const subclient = this.controller.allSubclients.filter((item) => item.sub_client.id !== this.currentSubclient.id);
        this.subclientsFilters = subclient.reverse();
        return subclient.reverse();
    }
    updateSubclient(subclient) {
        this.controller.changeSubclient(subclient.sub_client.id, null, '');
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], CustomerSwitcher.prototype, "currentSubclient", void 0);
CustomerSwitcher = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { Select: bmk_ui_framework_1.Select, WorldIcon: bmk_ui_framework_1.WorldIcon },
    })
], CustomerSwitcher);
exports.default = CustomerSwitcher;
